import { Component, Input } from '@angular/core';

// A form section laid out as [heading + description | field grid]. Project fields
// (typically app-labeled-field / app-setting-row) as content.
@Component({
    selector: 'app-form-section',
    templateUrl: './form-section.component.html',
    styleUrl: './form-section.component.scss'
})
export class FormSectionComponent {
  @Input({ required: true }) heading = '';
  @Input() description = '';
  @Input() columns: 1 | 2 = 2;
}
